export default __webpack_public_path__ + "static/media/data.4fece8c2.svg";